import React from "react";
import LogoGuides from "../../assets/guides.svg";
import LogoOutcomes from "../../assets/outcomes.svg";
import HeroGuides from "../../assets/guru-guides-hero.png";
import HeroOutcomes from "../../assets/guru-outcomes-hero.png";
import { useLanguage } from "../../context/LanguageContext";
import styles from "./index.module.css";

const Carousel: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.bannerOuter}>
      <mui-carousel-controller auto-rotate class={styles.banner}>
        <mui-tab-bar slot="controls" controlsPosition="bottom-right" variant="dots">
          <mui-tab-item active id="one" aria-label={t("guides.title")}></mui-tab-item>
          <mui-tab-item id="two" aria-label={t("outcomes.title")}></mui-tab-item>
        </mui-tab-bar>

        <mui-carousel-panel slot="item" item="one">
          <div className={styles.bannerInner}>
            <div className={styles.heroImageWrapper}>
              <img className={styles.heroImage} alt={t("guides.title")} width="496" height="290" src={HeroGuides} />
            </div>
            <mui-v-stack class={styles.bannerContent}>
              <mui-h-stack space="var(--space-400)" alignY="center">
                <div className={styles.bannerLogo}>
                  <img src={LogoGuides} alt="Guru Guides" style={{ width: "100%", height: "auto" }}></img>
                </div>
                <mui-heading level="3" size="2">
                  {t("guides.title")}
                </mui-heading>
              </mui-h-stack>
              <mui-body size="small">{t("guides.banner.description")}</mui-body>

              <mui-h-stack space="var(--space-400)" class={styles.bannerLinks}>
                <mui-link
                  href="https://www.figma.com/community/plugin/1471341082690554711/guru-guides"
                  target="_blank"
                  variant="primary"
                >
                  {t("guides.banner.primary")}
                </mui-link>
                <mui-link href="/guides" variant="secondary">
                  {t("guides.banner.secondary")}
                </mui-link>
              </mui-h-stack>
            </mui-v-stack>
          </div>
        </mui-carousel-panel>

        <mui-carousel-panel slot="item" item="two">
          <div className={styles.bannerInner}>
            <div className={styles.heroImageWrapper}>
              <img className={styles.heroImage} alt={t("outcomes.title")} width="496" height="290" src={HeroOutcomes} />
            </div>
            <mui-v-stack class={styles.bannerContent}>
              <mui-h-stack space="var(--space-400)" alignY="center">
                <div className={styles.bannerLogo}>
                  <img src={LogoOutcomes} alt="Guru Outcomes" style={{ width: "100%", height: "auto" }}></img>
                </div>
                <mui-heading level="3" size="2">
                  {t("outcomes.title")}
                </mui-heading>
              </mui-h-stack>
              <mui-body size="small">{t("outcomes.banner.description")}</mui-body>

              <mui-h-stack space="var(--space-400)" class={styles.bannerLinks}>
                <mui-link href="https://outcomes.gurusuite.xyz/" target="_blank" variant="primary">
                  {t("outcomes.banner.primary")}
                </mui-link>
                <mui-link href="/outcomes" variant="secondary">
                  {t("outcomes.banner.secondary")}
                </mui-link>
              </mui-h-stack>
            </mui-v-stack>
          </div>
        </mui-carousel-panel>
      </mui-carousel-controller>
    </div>
  );
};

export default Carousel;
